import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { injectIntl, defineMessages } from 'react-intl'
import { Title, BackLink, PageHeader } from '../../components'
import languageGrammar from '../../grammar/languageGrammar'


class LanguageGrammarRulesListPage extends React.Component {
  render() {
    const { intl, match } = this.props
    // const { currentLanguage, currentLanguageRules } = this.state

    const currentLanguage = match.params.id
    const currentLanguageRules = languageGrammar[match.params.id]
    
    if (!currentLanguageRules) {
      return null
    }

    return (
      <div className="page">
        <BackLink />
        <PageHeader title={intl.formatMessage(messages.title)} />
        
        <div className="flex-column width-full">
        {
          currentLanguageRules.map(grammarRule => (
            <div key={grammarRule.name}>
              <Link to={`/grammar/${currentLanguage}/${grammarRule.id}`}>
                <h3>{grammarRule.name}</h3>
              </Link>
              {
                grammarRule.subcategories ?
                  (<ul>
                    {grammarRule.subcategories.map(grammarRuleSub => (
                      <li key={grammarRuleSub.name}>{grammarRuleSub.name}</li>
                    ))}
                  </ul>)
                  :
                  null
              }
            </div>
          ))
        }
        </div>
      </div>
    )
  }
}

LanguageGrammarRulesListPage.propTypes = {
  intl: PropTypes.object.isRequired,
}

export default injectIntl(LanguageGrammarRulesListPage)

const messages = defineMessages({
  title: {
    id: 'languageGrammarRulesList.page.title',
    defaultMessage: 'Gramatické pravidlá',
  },
})



// WEBPACK FOOTER //
// ./src/browser/pages/grammar/LanguageGrammarRulesListPage.js